import { AppRoute, AppRoutes } from "core/AppRoutes";

import { ReactComponent as ActivityIcon } from "@icons/activity.svg";
import { ReactComponent as BreathingIcon } from "shared/assets/Icons/breathing.svg";
import { Icon } from "UIPalette/Icon/Icon";
import { ReactComponent as MoodIcon } from "shared/assets/Icons/face-neutral.svg";
import { ReactComponent as RightChevron } from "shared/assets/Icons/right.svg";
import { RoundedCard } from "shared/UI/RoundedCard/RoundedCard";
import { ReactComponent as SleepIcon } from "@icons/sleep.svg";
import { ReactComponent as StepsIcon } from "@icons/steps.svg";
import { Tracker } from "shared/request/myHealthyAdvantageApi";
import { ReactComponent as WaterIcon } from "@icons/water.svg";
import { useNavigate } from "react-router-dom";

export type TrackerCardProps = {
  tracker: Tracker;
};

export const TrackerCard = ({ tracker }: TrackerCardProps) => {
  const navigate = useNavigate();
  let pathToComponent: AppRoute = AppRoutes.wellbeing;

  const getIcon = () => {
    switch (tracker.ident) {
      case "mood":
        return <MoodIcon width="30" height="30" title={tracker.name} />;
      case "water":
        pathToComponent = AppRoutes.waterTracker;
        return <WaterIcon width="30" height="30" title={tracker.name} />;
      case "steps":
        pathToComponent = AppRoutes.stepsTracker;
        return <StepsIcon width="30" height="30" title={tracker.name} />;
      case "activity":
        pathToComponent = AppRoutes.activityTracker;
        return <ActivityIcon width="30" height="30" title={tracker.name} />;
      case "breathingexercises":
        pathToComponent = AppRoutes.breathingExercises;
        return <BreathingIcon width="30" height="30" title={tracker.name} />;
      case "sleep":
        pathToComponent = AppRoutes.sleepTracker;
        return <SleepIcon width="30" height="30" />;
    }

    throw new Error(`Unknown tracker type ${tracker.ident}`);
  };

  return (
    <button
      className="w-full text-left"
      onClick={() => {
        navigate(pathToComponent);
      }}
    >
      <RoundedCard>
        <div className="flex items-center">
          <Icon icon={getIcon()} bgColour="bg-brand-darker/10" hasDropShadow={false} />
          <p className="mx-4 grow">{tracker.description}</p>
          <div>
            <RightChevron className="text-grey" />
          </div>
        </div>
      </RoundedCard>
    </button>
  );
};
